/* ==========================================================================
   THE BOD 2026 — Theme JavaScript
   All interactive behaviors from the approved preview
   ========================================================================== */

(function () {
  'use strict';

  /* -----------------------------------------------------------------------
     Utility: DOM helpers
     ----------------------------------------------------------------------- */
  const $ = (sel, ctx) => (ctx || document).querySelector(sel);
  const $$ = (sel, ctx) => [...(ctx || document).querySelectorAll(sel)];

  /* -----------------------------------------------------------------------
     1. Announcement bar — close
     ----------------------------------------------------------------------- */
  const announce = $('#tbAnnounce');
  const announceClose = $('#announceClose');
  if (announce && announceClose) {
    announceClose.addEventListener('click', () => {
      announce.style.display = 'none';
      sessionStorage.setItem('tb_announce_closed', '1');
    });
    if (sessionStorage.getItem('tb_announce_closed') === '1') {
      announce.style.display = 'none';
    }
  }

  /* -----------------------------------------------------------------------
     2. Navigation — scroll shadow
     ----------------------------------------------------------------------- */
  const nav = $('#tbNav');
  if (nav) {
    let lastScroll = 0;
    window.addEventListener('scroll', () => {
      const y = window.scrollY;
      nav.classList.toggle('tb-nav--scrolled', y > 10);
      lastScroll = y;
    }, { passive: true });
  }

  /* -----------------------------------------------------------------------
     3. Mobile hamburger menu
     ----------------------------------------------------------------------- */
  const hamburger = $('#tbHamburger');
  const mobileMenu = $('#tbMobileMenu');
  if (hamburger && mobileMenu) {
    hamburger.addEventListener('click', () => {
      const isOpen = hamburger.getAttribute('aria-expanded') === 'true';
      hamburger.setAttribute('aria-expanded', !isOpen);
      hamburger.classList.toggle('tb-nav__hamburger--open', !isOpen);
      mobileMenu.classList.toggle('tb-nav__mobile--open', !isOpen);
      mobileMenu.setAttribute('aria-hidden', isOpen);
      document.body.style.overflow = isOpen ? '' : 'hidden';
    });
  }

  /* -----------------------------------------------------------------------
     4. Cart drawer
     ----------------------------------------------------------------------- */
  const cartToggle = $('#tbCartToggle');
  const cartDrawer = $('#tbCartDrawer');
  const cartClose = $('#tbCartClose');
  const cartOverlay = $('#tbCartOverlay');

  function openCart() {
    if (cartDrawer) {
      cartDrawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }
  }
  function closeCart() {
    if (cartDrawer) {
      cartDrawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }
  }

  if (cartToggle) cartToggle.addEventListener('click', openCart);
  if (cartClose) cartClose.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  /* -----------------------------------------------------------------------
     5. Accordion — FAQ + Pricing context
     ----------------------------------------------------------------------- */
  $$('[data-accordion-trigger]').forEach((trigger) => {
    trigger.addEventListener('click', () => {
      const expanded = trigger.getAttribute('aria-expanded') === 'true';
      const content = trigger.nextElementSibling;

      if (!content || !content.hasAttribute('data-accordion-content')) return;

      if (expanded) {
        trigger.setAttribute('aria-expanded', 'false');
        content.style.maxHeight = '0';
      } else {
        trigger.setAttribute('aria-expanded', 'true');
        content.style.maxHeight = content.scrollHeight + 'px';
      }
    });
  });

  /* -----------------------------------------------------------------------
     6. Counter animation (proof stats)
     ----------------------------------------------------------------------- */
  function animateCounters() {
    const counters = $$('.tb-counter');
    if (!counters.length) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        const el = entry.target;
        if (el.dataset.counted) return;
        el.dataset.counted = '1';

        const target = parseInt(el.dataset.target, 10) || 0;
        const suffix = el.dataset.suffix || '';
        const duration = 2000;
        const start = performance.now();

        function step(now) {
          const progress = Math.min((now - start) / duration, 1);
          const eased = 1 - Math.pow(1 - progress, 3); // easeOutCubic
          const current = Math.floor(eased * target);
          el.textContent = current.toLocaleString() + suffix;
          if (progress < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      });
    }, { threshold: 0.3 });

    counters.forEach((c) => observer.observe(c));
  }
  animateCounters();

  /* -----------------------------------------------------------------------
     7. Fade-in on scroll (IntersectionObserver)
     ----------------------------------------------------------------------- */
  function initFadeIn() {
    const elements = $$('.tb-fade-in');
    if (!elements.length) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('tb-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

    elements.forEach((el) => observer.observe(el));
  }
  initFadeIn();

  /* -----------------------------------------------------------------------
     8. How It Works — step progress line
     ----------------------------------------------------------------------- */
  function initHowItWorks() {
    const steps = $$('.tb-how__step');
    const lineFill = $('#tbHowLineFill');
    if (!steps.length || !lineFill) return;

    function updateLineFill() {
      const activeSteps = $$('.tb-step-active');
      if (activeSteps.length > 0) {
        const container = steps[0].parentElement;
        const lastActive = activeSteps[activeSteps.length - 1];
        const dot = lastActive.querySelector('.tb-how__step-dot');
        if (dot && container) {
          const containerRect = container.getBoundingClientRect();
          const dotRect = dot.getBoundingClientRect();
          const height = dotRect.top - containerRect.top + dot.offsetHeight / 2;
          lineFill.style.height = Math.max(0, height) + 'px';
        }
      }
    }

    /* Single observer for all steps — threshold 0 means "any pixel visible".
       Positive bottom rootMargin extends the trigger zone 200px below the
       viewport so the last step fires before the user even reaches it. */
    const stepObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('tb-step-active');
          stepObserver.unobserve(entry.target);
        }
      });
      updateLineFill();
    }, { threshold: 0, rootMargin: '0px 0px 200px 0px' });

    steps.forEach((s) => stepObserver.observe(s));

    /* Scroll-based fallback: if the user has scrolled past the section
       and the last step still has not animated, force-activate it. */
    function scrollFallback() {
      const lastStep = steps[steps.length - 1];
      if (lastStep && !lastStep.classList.contains('tb-step-active')) {
        const rect = lastStep.getBoundingClientRect();
        if (rect.top < window.innerHeight) {
          lastStep.classList.add('tb-step-active');
          stepObserver.unobserve(lastStep);
          updateLineFill();
        }
      }
    }
    window.addEventListener('scroll', scrollFallback, { passive: true });
  }
  initHowItWorks();


  /* -----------------------------------------------------------------------
     9. Sticky mobile CTA
     ----------------------------------------------------------------------- */
  function initStickyCta() {
    const stickyCta = $('#tbStickyCta');
    if (!stickyCta) return;

    /* Observe the hero section — show sticky bar once hero scrolls out */
    const hero = $('.tb-hero') || $('.tb-section-hero');
    if (!hero) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        stickyCta.classList.toggle('tb-sticky-cta--visible', !entry.isIntersecting);
      });
    }, { threshold: 0, rootMargin: '0px' });

    observer.observe(hero);
  }
  initStickyCta();

  /* -----------------------------------------------------------------------
     9b. Landing page sticky mobile CTA
     ----------------------------------------------------------------------- */
  function initLpStickyCta() {
    const stickyCta = $('#lpStickyCta');
    if (!stickyCta) return;

    const hero = $('.lp-hero');
    if (!hero) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        stickyCta.classList.toggle('is-visible', !entry.isIntersecting);
      });
    }, { threshold: 0, rootMargin: '0px' });

    observer.observe(hero);
  }
  initLpStickyCta();

  /* -----------------------------------------------------------------------
     10. Exit intent overlay — REMOVED
     Macro calculator now promoted via announcement bar.
     ----------------------------------------------------------------------- */

  /* -----------------------------------------------------------------------
     11. Smooth scroll for anchor links
     ----------------------------------------------------------------------- */
  $$('a[href^="#"]').forEach((link) => {
    link.addEventListener('click', (e) => {
      const id = link.getAttribute('href');
      if (id === '#' || id.length < 2) return;
      const target = $(id);
      if (!target) return;
      e.preventDefault();
      const offset = nav ? nav.offsetHeight + 16 : 80;
      const top = target.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top, behavior: 'smooth' });

      // Close mobile menu if open
      if (hamburger && hamburger.getAttribute('aria-expanded') === 'true') {
        hamburger.click();
      }
    });
  });

  /* -----------------------------------------------------------------------
     12. Keyboard accessibility — Escape to close overlays
     ----------------------------------------------------------------------- */
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      closeCart();
    }
  });

})();
